import { request } from '@/shared/api/request'

export const getCompanyAllowed = () => {
	return request({ url: '/contract/employer/isCompanyAllowed', method: 'GET' })
}

export const getActiveEmployeeList = () => {
	return request({ url: '/contract/employer/getActiveEmployeeList', method: 'GET' })
}

export const getFiredEmployeeList = () => {
	return request({ url: '/contract/employer/getFiredEmployeeList', method: 'GET' })
}

export const getEmployeeDates = ({ params }) =>
	request({ url: '/contract/employer/getEmployeeDates', method: 'GET', params: params })

export const getWorkByDate = ({ params }) =>
	request({ url: '/contract/employer/getWorkByDate', method: 'GET', params: params })
